/** @jsx jsx */
import { ComponentProps } from 'react';
import { jsx } from '@emotion/core';
import { Alert, Button, Margin, Spacer, Text } from '@zapier/design-system';
import { useActiveProfile } from 'app/developer-v3/hooks';

type Props = {
  margin: ComponentProps<typeof Margin>['margin'];
};

const OAuthErrorMessage = (props: Props) => {
  // Zapier staff check
  const { activeProfile, error: errorActiveProfile } = useActiveProfile();
  if (errorActiveProfile) {
    console.error(errorActiveProfile);
  }
  const isStaff = activeProfile?.isStaff ?? false;

  return (
    <Margin margin={props.margin}>
      {isStaff ? (
        <Alert status="error" title="Failed to load OAuth app data">
          To view this OAuth application, please go to the Django admin.
        </Alert>
      ) : (
        <Alert
          status="error"
          title="Contact us to configure your OAuth application"
        >
          <Text margin="5px 0 10px" tag="p" type="Body1">
            Your OAuth application is needed for this feature but it has not yet
            been configured. We can help you sort that out!
          </Text>
          <Button
            color="primary"
            href="mailto:partners@zapier.com"
            isFullWidth={false}
            size="compact"
          >
            Email partner support
          </Button>
          <Spacer height="10px" />
        </Alert>
      )}
    </Margin>
  );
};

export default OAuthErrorMessage;
